import styled from "styled-components";
import { TipMouseOutEvent , TipMouseOverEvent } from "../../Tooltip/Tooltip";
import { useEffect } from "react";
import AprendizMF from "./img/NOVICE.gif"
import SarahImg from "./img/MM_SARAH.gif"
import FenrirImg from "./img/FENRIR.gif"
import LadyTaneeImg from "./img/LADY_TANEE.gif"
import Colapsider from "../../Colapsiders/Colapsider"
import FirstClassImg from "./img/filter_1.png"
import SecondClassImg from "./img/filter_2.png"
import TransclassesImg from "./img/assignment.png"
import ThirdClassImg from "./img/filter_3.png"
import ExpandedImg from "./img/explicit.png"
import SummonerImg from "./img/pets.png"
import CityQuestImg from "./img/question_answer.png"
import {WavSoundEffect } from "../../WavSoundEffects/WavSoundEffects";
import PublicImage from "./img/public.png"
import GeralImage from "./img/schedule.png"
import Brightnes4Image from "./img/brightness_4.png"
import BoatImage  from "./img/directions_boat_filled.png"
import BoardStarImage  from "./img/star_border.png"
import HalfStarImage  from "./img/star_half.png"
import FullStarImage  from "./img/star.png"
import FireImage  from "./img/whatshot.png"
import FogImage  from "./img/lens_blur.png"
import SpecialStarImage  from "./img/stars.png"
import HdrWeekImage  from "./img/hdr_weak.png"
import FirstClassQuests from "./ClassesDescription/FirstClassesQuests";
import SecondClassQuests from "./ClassesDescription/SecondClassesQuests";
import TransClassQuests from "./ClassesDescription/TransClassesQuests";
import ThirdClassQuests from "./ClassesDescription/ThirdClassesQuests";
import NewRacesQuests from "./ClassesDescription/NewRacesQuests";
import ExpandedQuests from "./ClassesDescription/ExpandedQuests";
import NewWorldQuests from "./InstancesDescription/NewWorldQuests";
import GeneralQuests from "./InstancesDescription/GeralQuests";
import MalayaPortQuests from "./InstancesDescription/MalayaPort";
import MalangdoIslandQuests from "./InstancesDescription/MalangdoIsland";
import HeroTrackI from "./InstancesDescription/HeroTrackI"
import HeroTrackII from "./InstancesDescription/HeroTrackII"
import HeroTrackIII from "./InstancesDescription/HeroTrackIII"
import FinalConfront from "./InstancesDescription/FinalConfront"
import Fantasmagorica from "./InstancesDescription/Fantasmagorica"
import BanquetOfHeroes from "./InstancesDescription/BanquetOfHeroes"
import TerraGloria from "./InstancesDescription/TerraGloria"

function Guias(){

        useEffect(() => {setTimeout(() => {  document.getElementById("GuiasContainer").style.opacity = 1}, 200)})

    return(
    <GuiasContainer id="GuiasContainer">
        <TitleContainer>
        <Title>Guias para quest e instâncias.</Title>
        <T1>
            Aqui você encontra as listas detalhadas de quests, instâncias para superar e explorar todos os desafios de Rune - Midgard!<br/>
            Para Instâncias, lembre-se que existe um <b>tempo de espera</b> para repetir a quest após finalizá-la.
        </T1>
        </TitleContainer>

        <GuideContainerMaster>

            <GuideContainer>
                <GuideContainerImgs>
                    <GuideContainerGif
                    onMouseOver={
                        (event) => {
                            TipMouseOverEvent(event, "Lets go♪<br> (não clique!)", "rgb(33, 33, 33)");
                            WavSoundEffect('/wav/_attack_dagger.wav', ' ', 'hover')}}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={AprendizMF}
                    width={"135px"} height={"120px"} margin={"12px 0"}
                    onClick={() => WavSoundEffect(' ', '/bgm/14.mp3', 'click')}/>

                </GuideContainerImgs>
                <h1>Guia de Classes</h1>
                <span>Guias sobre as classes disponíveis no mundo de Ragnarok Online as respectivas quest de evolução para cada classe.</span>

                <Colapsider containerWidth={"380px"} properties={[
                    ["01", FirstClassImg, "1st - Classes Primárias",<FirstClassQuests/>],
                    ["02", SecondClassImg, "2st - Classes Secundárias",<SecondClassQuests/>],
                    ["03", TransclassesImg, "Transclasses - Renascimento",<TransClassQuests/>],
                    ["04", ThirdClassImg, "3st - Terceiras Classes",<ThirdClassQuests/>],
                    ["05", ExpandedImg, "Classes Especiais - Expandidas",<ExpandedQuests/>],
                    ["06", SummonerImg, "Summoner - Nova Raça",<NewRacesQuests/>],
                    ]}/>

            </GuideContainer>

            <GuideContainer>
                <GuideContainerImgs>
                    <GuideContainerGif
                    onClick={() => WavSoundEffect(' ', '/bgm/157.mp3', 'click')}
                    onMouseOver={(event) => {
                        TipMouseOverEvent(event, "Hmph!<br> (não clique!)", "rgb(177, 65, 65)");
                        WavSoundEffect('/wav/_attack_dagger.wav', ' ', 'hover')}}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={SarahImg} width={"100px"} height={"145px"} margin={"0"}/>

                    <GuideContainerGif
                    onClick={() => WavSoundEffect(' ', '/bgm/13.mp3', 'click')}
                    onMouseOver={(event) => {
                        TipMouseOverEvent(event, "...<br> (não clique!)", "rgb(61, 114, 179)");
                        WavSoundEffect('/wav/_attack_dagger.wav', ' ', 'hover')}}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={FenrirImg} width={"50px"} height={"120px"} margin={"0"} />

                </GuideContainerImgs>
                <h1>Quests Especiais - Instâncias</h1>
                <span> Guias para realizar as instâncias (quests especiais) por episódeo.</span>

                <Colapsider containerWidth={"400px"} properties={[
                    ["07", PublicImage, "Novo Mundo", <NewWorldQuests/>],
                    ["08", GeralImage, "Gerais",<GeneralQuests/>],
                    ["09", Brightnes4Image, "Porto de Malaya", <MalayaPortQuests/>],
                    ["10", BoatImage, "Ilha de Malangdo",<MalangdoIslandQuests/>],
                    ["11", BoardStarImage, "Trilha dos Heróis - Par I", <HeroTrackI/> ],
                    ["12", HalfStarImage, "Trilha dos Heróis - Par II",<HeroTrackII/>],
                    ["13", FullStarImage, "Trilha dos Heróis - Par III",<HeroTrackIII/>],
                    ["14", FireImage, "Confronto Final - Batalha Decisiva",<FinalConfront/>],
                    ["15", FogImage, "Fantasmagórica",<Fantasmagorica/>],
                    ["16", SpecialStarImage, "Banquete para os Heróis",<BanquetOfHeroes/>],
                    ["17", HdrWeekImage, "Terra Glória", <TerraGloria/>]
                    ]}/>

            </GuideContainer>

            <GuideContainer>
                <GuideContainerImgs>
                    <GuideContainerGif
                    onMouseOver={(event) => {
                        TipMouseOverEvent(event, "Hmm♪ Hmm♪<br> (não clique!)", "rgb(30, 156, 18)");
                        WavSoundEffect('/wav/loli_ruri_stand.wav', ' ', 'hover')}}
                    onMouseLeave={() => TipMouseOutEvent()}
                    img={LadyTaneeImg} width={"150px"} height={"145px"} margin={"0"}
                    onClick={() => WavSoundEffect(' ', '/bgm/82.mp3', 'click')}/>
                    
                </GuideContainerImgs>
                <h1>Quests por Cidade</h1>
                <span>Guias para realizar as quests disponíveis de cada cidade.</span>

                <Colapsider containerWidth={"400px"} properties={[
                    ["18", CityQuestImg, "Alberta",<></>],
                    ["19", CityQuestImg, "Al De Baran",<></>],
                    ["20", CityQuestImg, "Amatsu",<></>],
                    ["21", CityQuestImg, "Ayothaya",<></>],
                    ["22", CityQuestImg, "Brasilis",<></>],
                    ["23", CityQuestImg, "Comodo",<></>],
                    ["24", CityQuestImg, "Dewata",<></>],
                    ["25", CityQuestImg, "Eclage",<></>],
                    ["26", CityQuestImg, "Einbroch",<></>],
                    ["27", CityQuestImg, "Einbech",<></>],
                    ["28", CityQuestImg, "El Dicastes",<></>],
                    ["29", CityQuestImg, "Geffen",<></>],
                    ["30", CityQuestImg, "Hugel",<></>],
                    ["31", CityQuestImg, "Izlude",<></>],
                    ["32", CityQuestImg, "Juno",<></>],
                    ["33", CityQuestImg, "Kunlun",<></>],
                    ["34", CityQuestImg, "Lasagna",<></>],
                    ["35", CityQuestImg, "Lighthalzen",<></>],
                    ["36", CityQuestImg, "Louyang",<></>],
                    ["37", CityQuestImg, "Lutie",<></>],
                    ["38", CityQuestImg, "Malangdo",<></>],
                    ["39", CityQuestImg, "Malaya",<></>],
                    ["40", CityQuestImg, "Manuk",<></>],
                    ["41", CityQuestImg, "Morroc",<></>],
                    ["42", CityQuestImg, "Mora",<></>],
                    ["43", CityQuestImg, "Moscóvia",<></>],
                    ["44", CityQuestImg, "Nilfhein",<></>],
                    ["45", CityQuestImg, "Payon",<></>],
                    ["46", CityQuestImg, "Prontera",<></>],
                    ["47", CityQuestImg, "Rachel",<></>],
                    ["48", CityQuestImg, "Splendide",<></>],
                    ["49", CityQuestImg, "Umbala",<></>],
                    ["50", CityQuestImg, "Veins",<></>]
                    ]}/>
            </GuideContainer>


        </GuideContainerMaster>
        

    </GuiasContainer>
    );
};

const GuiasContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: space-evenly;
    transition: 2s;
    //border: solid;
    margin-bottom: 50px;

    @media (max-width: 1000px) {
    width: 90vw;
    }
    opacity: 0;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1280px;
    //border: solid;

    @media (max-width: 1000px) {
    width: 90vw;
    text-align: justify;
    margin-bottom: 10px;
    }
`;

const Title = styled.h1`
    font-size: 32pt;

    @media (max-width: 1000px) {
    font-size: 24pt;
    text-align: center;
    }
`;

const T1 = styled.div`
    font-size: 12pt;
    text-align: justify;

    @media (max-width: 1000px) {
    overflow: auto;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 black;
    }
`;

const GuideContainerMaster = styled.div`
    display: flex;
    justify-content: center;
    margin: 50px 0;
    //border: solid;

     @media (max-width: 1200px) {
    width: 90vw;
    flex-direction: column;
    align-items: center;
    margin: 10px 0;
    }
`;

const GuideContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 450px;
    //border: solid;

    @media (max-width: 1200px) {
    margin: 50px 0;
    width: 90vw;
    }
    
`

const GuideContainerImgs = styled.div`
    display: flex;
    align-items: center;

`

const GuideContainerGif = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    margin: ${props => props.margin};
    width: ${props => props.width};
    height: ${props => props.height};
    
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

`


export default Guias;